import axios from 'axios';

const axiosInstance = axios.create();

// Response interceptor — only 401 (invalid/expired token) ends the session.
// 403 means "authenticated but not permitted" for that endpoint — the caller
// handles it; it must NOT log the user out (e.g. Marketing hitting an admin-only API).
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Request interceptor — attach Bearer token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
